// removed by extract-text-webpack-plugin
module.exports = {"body":"src-pages----index-module---body---3CZU5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/index.module.css
// module id = 306
// module chunks = 35783957827783